import dataProviderCreate from 'providers/data_provider/rails/create';
import getAxios from 'getAxios';

const create = async (url: string, data: object, resource = '') => {
  const axios = getAxios();
  return dataProviderCreate(axios)(resource, { data }, url);
};

export default create;
